webpackJsonp([51],{

/***/ 1304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






var metas = {
  "category": {
    "en": "Feedback",
    "zh-CN": "弹窗提示"
  },
  "icon": "&#xe610;",
  "tags": {
    "en": ["loading", "dialog"],
    "zh-CN": ["加载", "弹窗", "提示"]
  },
  "extra": "该组件支持以`plugin`形式调用：\n\n``` js\nimport  { LoadingPlugin } from 'vux'\nVue.use(LoadingPlugin)\n\n// 或者umd方式\n// 引入构建的js文件\nVue.use(vuxLoadingPlugin)\n```\n\n``` js\n// 显示\nthis.$vux.loading.show({\n text: 'Loading'\n})\n\n// 隐藏\nthis.$vux.loading.hide()\n\n// 获取显示状态\nthis.$vux.loading.isVisible() // true or false, v2.9.1 版本支持\n```\n::: tip\nloading同样支持在vue外直接使用，请参照 [https://github.com/airyland/vux/blob/v2/docs/examples/loading.html](https://github.com/airyland/vux/blob/v2/docs/examples/loading.html)\n:::\n\n::: tip\n从v2.7.8版本开始以组件形式调用增加`delay`参数，从而实现延时显示.\n:::\n",
  "props": {
    "show": {
      "type": "Boolean",
      "default": false,
      "en": "visibility of the component. Use `v-model` for binding before v2.5.7, otherwise use `:show`",
      "zh-CN": "显示状态，在 v2.5.7 前使用`v-model`绑定，后面直接使用 `:show` 绑定"
    },
    "text": {
      "type": "String",
      "default": "加载中",
      "en": "loading text, use empty string to hide loading text",
      "zh-CN": "提示文字，值为空字符时隐藏提示文字"
    },
    "position": {
      "type": "String",
      "default": "fixed",
      "en": "position, default is `fixed`, you can use `absolute`",
      "zh-CN": "定位方式，默认为`fixed`，在100%的布局下用`absolute`可以避免抖动"
    },
    "transition": {
      "type": "String",
      "default": "vux-mask",
      "en": "transition name",
      "zh-CN": "显示动画名字"
    }
  },
  "slots": {
    "default": {
      "en": "content area",
      "zh-CN": "提示文字区域"
    }
  },
  "changes": {
    "v2.9.1": {
      "en": ["[feature] add isVisible function for LoadingPlugin #2704", "[fix] fix covered by element when using scroll plugins"],
      "zh-CN": ["[feature] 添加 isVisible 获取当前显示状态 #2704", "[fix] 修复使用类 scroll 组件时会被覆盖的问题"]
    },
    "v2.9.0": {
      "en": ["[fix] add variable loading-z-index #2484", "[enhance] support using empty text to hide loading text #2566"],
      "zh-CN": ["[fix] 添加变量 loading-z-index 避免与 toast-z-index 冲突 #2484", "[enhance] 支持使用空字符隐藏提示文字 #2566"]
    },
    "v2.5.7": {
      "en": ["[fix] fix vue@2.4 no setter warning, use :show instead of v-model #1798"],
      "zh-CN": ["[fix] 修复 vue@2.4 no setter 警告，可以直接用 :show 绑定 #1798"]
    },
    "v2.5.0": {
      "en": ["[feature] Add prop:transition"],
      "zh-CN": ["[feature] 支持 prop:transition"]
    },
    "v2.1.1-rc.11": {
      "en": ["[enhance] Reset prop data when used as plugin", "[enhance] Add fade transition"],
      "zh-CN": ["[enhance] 以插件形式使用时强制重置属性值", "[enhance] 添加渐现动画"]
    },
    "v2.0.1": {
      "zh-CN": ["[fix] i18n 无配置"]
    }
  },
  "variables": [{
    "name": "loading-z-index",
    "value": "5001",
    "is_inherited": false,
    "inherited_name": "",
    "desc": {
      "zh-CN": "z-index",
      "en": "z-index"
    }
  }]
};
var demos = [];

var componentList = [];
if (Array.isArray(metas.items)) {
  try {
    metas.items.forEach(function (item, index) {
      var meta = {
        name: item,
        meta: metas[item]
      };
      if (meta.meta.props === null) {
        delete meta.meta.props;
      }
      if (index === metas.items.length - 1) {
        if (meta.meta) {
          meta.meta.variables = metas.variables;
        }
      }
      componentList.push(meta);
    });
  } catch (e) {
    console.log(e);
  }
} else {
  componentList.push({
    meta: metas
  });
}
var gitMetas = __webpack_require__(2518);
var demoCode = decodeURIComponent("%3Cpre%20class%3D%22hljs%22%3E%3Ccode%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Etemplate%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Toggle')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-model%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22show1%22%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eon-change%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22show1change%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('No%20loading%20text')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-model%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22show2%22%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eon-change%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22show2change%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-transfer-dom%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Eloading%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Ashow%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22show1%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atext%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22text1%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Eloading%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-transfer-dom%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Eloading%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Ashow%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22show2%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etext%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Eloading%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Estyle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22padding%3A%2015px%3B%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showLoading%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etype%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22primary%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%7B%7B%20%24t('Show%20loading')%20%7D%7D%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Estyle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22padding%3A%2015px%3B%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showDelayLoading%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etype%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22primary%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%7B%7B%20%24t('Show%20delay%20loading')%20%7D%7D%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Etemplate%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ei18n%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0AShow%20loading%3A%0A%20%20en%3A%20show%20loading%20(close%20in%202s)%0A%20%20zh-CN%3A%20%E6%98%BE%E7%A4%BAloading%20(2s%E5%90%8E%E5%85%B3%E9%97%AD)%0AShow%20delay%20loading%3A%0A%20%20en%3A%20show%20loading%20delay%20after%201s%0A%20%20zh-CN%3A%20%E5%BB%B6%E6%97%B61s%E5%90%8E%E6%98%BE%E7%A4%BA%0ANo%20loading%20text%3A%0A%20%20zh-CN%3A%20%E6%97%A0%E6%8F%90%E7%A4%BA%E6%96%87%E5%AD%97%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ei18n%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Escript%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22javascript%22%3E%0A%3Cspan%20class%3D%22hljs-keyword%22%3Eimport%3C%2Fspan%3E%20%7B%20Loading%2C%20Group%2C%20XSwitch%2C%20XButton%2C%20TransferDomDirective%20%3Cspan%20class%3D%22hljs-keyword%22%3Eas%3C%2Fspan%3E%20TransferDom%20%7D%20%3Cspan%20class%3D%22hljs-keyword%22%3Efrom%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-string%22%3E'vux'%3C%2Fspan%3E%0A%0A%3Cspan%20class%3D%22hljs-keyword%22%3Eexport%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-keyword%22%3Edefault%3C%2Fspan%3E%20%7B%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3Edirectives%3C%2Fspan%3E%3A%20%7B%0A%20%20%20%20TransferDom%0A%20%20%7D%2C%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3Ecomponents%3C%2Fspan%3E%3A%20%7B%0A%20%20%20%20Loading%2C%0A%20%20%20%20Group%2C%0A%20%20%20%20XSwitch%2C%0A%20%20%20%20XButton%0A%20%20%7D%2C%0A%20%20data%20()%20%7B%0A%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ereturn%3C%2Fspan%3E%20%7B%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Eshow1%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Eshow2%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Etext1%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-string%22%3E'Processing'%3C%2Fspan%3E%0A%20%20%20%20%7D%0A%20%20%7D%2C%0A%20%20mounted%20()%20%7B%0A%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ethis%3C%2Fspan%3E.timer%20%3D%20setInterval(%3Cspan%20class%3D%22hljs-function%22%3E%3Cspan%20class%3D%22hljs-params%22%3E()%3C%2Fspan%3E%20%3D%26gt%3B%3C%2Fspan%3E%20%7B%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-built_in%22%3Econsole%3C%2Fspan%3E.log(%3Cspan%20class%3D%22hljs-keyword%22%3Ethis%3C%2Fspan%3E.%24vux.loading.isVisible())%0A%20%20%20%20%7D%2C%20%3Cspan%20class%3D%22hljs-number%22%3E1000%3C%2Fspan%3E)%0A%20%20%7D%2C%0A%20%20beforeDestroy%20()%20%7B%0A%20%20%20%20clearInterval(%3Cspan%20class%3D%22hljs-keyword%22%3Ethis%3C%2Fspan%3E.timer)%0A%20%20%7D%2C%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3Emethods%3C%2Fspan%3E%3A%20%7B%0A%20%20%20%20showLoading%20()%20%7B%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ethis%3C%2Fspan%3E.%24vux.loading.show(%7B%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Etext%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-string%22%3E'Loading'%3C%2Fspan%3E%0A%20%20%20%20%20%20%7D)%0A%20%20%20%20%20%20setTimeout(%3Cspan%20class%3D%22hljs-function%22%3E%3Cspan%20class%3D%22hljs-params%22%3E()%3C%2Fspan%3E%20%3D%26gt%3B%3C%2Fspan%3E%20%7B%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ethis%3C%2Fspan%3E.%24vux.loading.hide()%0A%20%20%20%20%20%20%7D%2C%20%3Cspan%20class%3D%22hljs-number%22%3E2000%3C%2Fspan%3E)%0A%20%20%20%20%7D%2C%0A%20%20%20%20showDelayLoading%20()%20%7B%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ethis%3C%2Fspan%3E.%24vux.loading.show(%7B%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Etext%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-string%22%3E'Loading'%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Edelay%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-number%22%3E1e3%3C%2Fspan%3E%0A%20%20%20%20%20%20%7D)%0A%20%20%20%20%20%20setTimeout(%3Cspan%20class%3D%22hljs-function%22%3E%3Cspan%20class%3D%22hljs-params%22%3E()%3C%2Fspan%3E%20%3D%26gt%3B%3C%2Fspan%3E%20%7B%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ethis%3C%2Fspan%3E.%24vux.loading.hide()%0A%20%20%20%20%20%20%7D%2C%20%3Cspan%20class%3D%22hljs-number%22%3E2000%3C%2Fspan%3E)%0A%20%20%20%20%7D%2C%0A%20%20%20%20show1change%20(val)%20%7B%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Eif%3C%2Fspan%3E%20(val)%20%7B%0A%20%20%20%20%20%20%20%20tick(%3Cspan%20class%3D%22hljs-number%22%3E0%3C%2Fspan%3E%2C%20(percent)%20%3D%26gt%3B%20%7B%0A%20%20%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Eif%3C%2Fspan%3E%20(percent%20%3D%3D%3D%20%3Cspan%20class%3D%22hljs-number%22%3E100%3C%2Fspan%3E)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ethis%3C%2Fspan%3E.show1%20%3D%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ereturn%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ethis%3C%2Fspan%3E.text1%20%3D%20%3Cspan%20class%3D%22hljs-string%22%3E%60%3Cspan%20class%3D%22hljs-subst%22%3E%24%7Bpercent%7D%3C%2Fspan%3E%25%60%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%7D)%0A%20%20%20%20%20%20%7D%0A%20%20%20%20%7D%2C%0A%20%20%20%20show2change%20(val)%20%7B%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Eif%3C%2Fspan%3E%20(val)%20%7B%0A%20%20%20%20%20%20%20%20tick(%3Cspan%20class%3D%22hljs-number%22%3E0%3C%2Fspan%3E%2C%20(percent)%20%3D%26gt%3B%20%7B%0A%20%20%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Eif%3C%2Fspan%3E%20(percent%20%3D%3D%3D%20%3Cspan%20class%3D%22hljs-number%22%3E100%3C%2Fspan%3E)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ethis%3C%2Fspan%3E.show2%20%3D%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ereturn%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%7D)%0A%20%20%20%20%20%20%7D%0A%20%20%20%20%7D%0A%20%20%7D%0A%7D%0A%0A%3Cspan%20class%3D%22hljs-function%22%3E%3Cspan%20class%3D%22hljs-keyword%22%3Efunction%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-title%22%3Etick%3C%2Fspan%3E%20(%3Cspan%20class%3D%22hljs-params%22%3Ei%2C%20cb%3C%2Fspan%3E)%20%3C%2Fspan%3E%7B%0A%20%20setTimeout(%3Cspan%20class%3D%22hljs-function%22%3E%3Cspan%20class%3D%22hljs-keyword%22%3Efunction%3C%2Fspan%3E%20(%3Cspan%20class%3D%22hljs-params%22%3E%3C%2Fspan%3E)%20%3C%2Fspan%3E%7B%0A%20%20%20%20i%2B%2B%0A%20%20%20%20cb(i)%0A%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Eif%3C%2Fspan%3E%20(i%20%26lt%3B%20%3Cspan%20class%3D%22hljs-number%22%3E100%3C%2Fspan%3E)%20%7B%0A%20%20%20%20%20%20tick(i%2C%20cb)%0A%20%20%20%20%7D%0A%20%20%7D%2C%20%3Cspan%20class%3D%22hljs-number%22%3E10%3C%2Fspan%3E)%0A%7D%0A%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Escript%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%3C%2Fcode%3E%3C%2Fpre%3E");

var domainMap = {
  'development': 'http://localhost:8080/',
  'production': 'https://vux-demos.bobjoy.eu.org/'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  head: {
    title: 'Loading 组件使用教程 | VUX - 基于 WeUI 和 Vue 的移动端组件库',
    meta: [{
      name: 'description',
      content: 'Vue component loading for the VUX framework.'
    }, {
      name: 'keywords',
      content: 'loading, vue-loading, vux-loading, vue mobile components'
    }, {
      property: 'og:title',
      content: 'Loading 组件使用教程 | VUX - 基于 WeUI 和 Vue 的移动端组件库'
    }, {
      property: 'og:description',
      content: 'Vue component loading for the VUX framework.'
    }],

    link: [{ "rel": "alternate", "hreflang": "en", "href": "/en/components/loading.html" }],
    script: [{
      innerHTML: '{"@context":"http://schema.org/","@type":"SoftwareApplication","name":"Vue Component loading","screenshot":"","description":"Vue.js component for VUX","url":"/zh-CN/components/loading.html","applicationCategory":"组件","author":{"@type":"Organization","name":"VUX","url":"https://vux.li"},"downloadUrl":"https://vux.li","softwareVersion":"2.11.1","aggregateRating":{"@type":"AggregateRating","ratingValue":5,"reviewCount":1},"operatingSystem":"iOS >= 7, Android >= 4.1","offers":{"@type":"Offer","price":0,"priceCurrency":"CNY","availability":"http://schema.org/InStock"}}',
      type: 'application/ld+json'
    }],
    __dangerouslyDisableSanitizers: ['script']
  },
  filters: {
    parseCode: function parseCode(str) {
      return str.replace(/`(.*?)`/g, '<code>$1</code>');
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var rs;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://api.github.com/search/issues?q=repo:airyland/vux%20label:component/' + _this.componentName);

            case 2:
              rs = _context.sent;

              _this.issues = rs.data.items;
              _this.hasReady = true;

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    sourceCodeDialogVisibility: function sourceCodeDialogVisibility(val) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var mask;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!val) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return _this2.$nextTick();

              case 3:
                mask = document.querySelector('.v-modal');

                mask && mask.addEventListener('click', function () {
                  _this2.sourceCodeDialogVisibility = false;
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  methods: {
    onCopyError: function onCopyError() {
      this.$message({
        type: 'error',
        message: '复制失败'
      });
    },
    onCopy: function onCopy() {
      this.$message({
        type: 'success',
        message: '复制成功'
      });
    },
    showSourceCode: function showSourceCode() {
      this.sourceCodeDialogVisibility = true;
    },
    getTypeHTML: function getTypeHTML(type) {
      type = type || 'String';
      if (/,/.test(type)) {
        var list = type.split(',').map(function (one) {
          return one.replace(/^s+|s+$/g, '');
        }).map(function (one) {
          var type = one ? one.toLowerCase() : 'string';
          return '<span class="type">' + type + '</span>';
        });
        return list.join('<br>');
      } else {
        type = type ? type.toLowerCase() : 'string';
        return '<span class="type">' + type + '</span>';
      }
    }
  },
  computed: {
    lang: function lang() {
      if (this.$route.path.indexOf('/en/') !== -1) {
        return 'en';
      }
      if (this.$route.path.indexOf('/zh-CN/') !== -1) {
        return 'zh-CN';
      }
      return 'en';
    }
  },
  data: function data() {
    return {
      demos: demos,
      isBeta: false,
      hasReady: false,
      issues: [],
      componentName: 'loading',
      demoCode: demoCode,
      sourceCodeDialogVisibility: false,
      showQr: false,
      metas: metas,
      gitMetas: gitMetas,
      componentList: componentList,
      localImportCode: "import { Loading } from 'vux'\n\nexport default {\n  components: {\n    Loading\n  }\n}",
      globalImportCode: "// \u5728\u5165\u53E3\u6587\u4EF6\u5168\u5C40\u5F15\u5165\n\nimport Vue from 'vue'\nimport { Loading } from 'vux'\n\nVue.component('loading', Loading)\n",
      needImport: true,
      toc: [],
      domain: domainMap["production"]
    };
  }
});

/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(306)(false);
// imports


// module
exports.push([module.i, ".component-box{position:relative}.component-demo{position:absolute;right:5px;top:15px}.prop-color{display:inline-block;width:10px;height:10px;border:1px solid #aaa}.changelog-version{width:110px;display:inline-block}.component-extra-links{position:relative;font-size:12px}.component-extra-links a{padding-right:10px;color:#999}", ""]);

// exports


/***/ }),

/***/ 1618:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1452);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(307)("3dd40e89", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"autoprefixer\":false,\"sourceMap\":false,\"minimize\":true}!../../node_modules/ream/node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6ba5a284\",\"scoped\":false,\"hasInlineConfig\":true}!../../node_modules/ream/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loading.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"autoprefixer\":false,\"sourceMap\":false,\"minimize\":true}!../../node_modules/ream/node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6ba5a284\",\"scoped\":false,\"hasInlineConfig\":true}!../../node_modules/ream/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loading.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2311:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-box",
    class: _vm.demos.length ? 'components-with-toc' : ''
  }, [_c('div', {
    class: _vm.demos.length ? 'component-header-v2' : 'component-header-v1'
  }, [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "intro"
    }
  }, [_vm._v("Loading")]), _c('div', {
    staticClass: "title-box"
  }, [(_vm.isBeta) ? _c('el-badge', {
    attrs: {
      "value": "Beta"
    }
  }, [_c('h1', {
    staticClass: "vux-component-name"
  }, [_vm._v("Loading")])]) : _c('h1', {
    staticClass: "vux-component-name"
  }, [_vm._v("Loading")]), _c('p', {
    staticClass: "component-extra-links"
  }, [_c('a', {
    attrs: {
      "href": "https://vux-demos.bobjoy.eu.org/#/component/loading",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")]), (!_vm.demos.length) ? _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Loading.vue",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSourceCode($event)
      }
    }
  }, [_vm._v("demo 源码")]) : _vm._e(), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/loading/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("编辑文档")]), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/loading/",
      "target": "_blank"
    }
  }, [_vm._v("组件源码")]), (_vm.hasReady) ? _c('el-popover', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "qr",
    attrs: {
      "width": "100",
      "src": "https://qr.vux.li/api.php?text=https%3A%2F%2Fvux-demos.bobjoy.eu.org%2F%23%2Fcomponent%2Floading"
    }
  })]), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    slot: "reference"
  }, [_vm._v("\n              二维码\n              ")])]) : _vm._e()], 1), _c('div', {
    staticClass: "component-description"
  }, [(false) ? void 0 : _vm._e()], 2)], 1), (!_vm.demos.length) ? _c('div', {
    staticClass: "component-demo",
    staticStyle: {
      "width": "377px",
      "height": "600px",
      "display": "inline-block",
      "border": "1px solid #ececec",
      "border-radius": "5px",
      "overflow": "hidden",
      "z-index": "2500"
    }
  }, [_c('iframe', {
    attrs: {
      "src": "https://vux-demos.bobjoy.eu.org?locale=zh-CN&transition=none/#/component/loading",
      "width": "375",
      "height": "600",
      "border": "0",
      "frameborder": "0"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "toc"
  }, _vm._l((_vm.toc), function(t) {
    return _c('ul', [_c('li', [_c('a', {
      attrs: {
        "href": '#' + (t.anchor || t.title)
      }
    }, [_vm._v(_vm._s(t.title))]), _vm._l((t.list), function(_t) {
      return (t.list) ? _c('ul', [_c('li', [_c('a', {
        attrs: {
          "href": '#' + _t.anchor
        }
      }, [_vm._v(_vm._s(_t.title.slice(0, 12)))])])]) : _vm._e()
    })], 2)])
  })), (_vm.needImport) ? [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "install"
    }
  }, [_vm._v("Install")]), _c('h2', [_vm._v("安装")]), _c('el-tabs', [_c('el-tab-pane', {
    attrs: {
      "label": "局部注册"
    }
  }, [_c('div', {
    staticClass: "import-code-box"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "点击复制",
      "placement": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.localImportCode),
      expression: "localImportCode",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onCopyError),
      expression: "onCopyError",
      arg: "error"
    }]
  }, [_c('el-icon', {
    staticClass: "el-icon-document"
  })], 1)]), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Loading } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("components")]), _vm._v(": {\n    Loading\n  }\n}")])])], 1)]), _c('el-tab-pane', {
    attrs: {
      "label": "全局注册"
    }
  }, [_c('div', {
    staticClass: "import-code-box"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "点击复制",
      "placement": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.globalImportCode),
      expression: "globalImportCode",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onCopyError),
      expression: "onCopyError",
      arg: "error"
    }]
  }, [_c('el-icon', {
    staticClass: "el-icon-document"
  })], 1)]), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 在入口文件全局引入")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" Vue "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vue'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Loading } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\nVue.component("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'loading'")]), _vm._v(", Loading)\n")])])], 1)])], 1)] : [_c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("该组件可以直接使用，不需要引入。")])])], (_vm.metas.tip) ? _c('div', {
    staticClass: "tip",
    staticStyle: {
      "width": "600px"
    }
  }) : _vm._e(), (_vm.metas.example) ? _c('h2', [_vm._v("使用例子")]) : _vm._e(), (_vm.metas.example) ? _c('div', {
    staticStyle: {
      "width": "600px"
    }
  }) : _vm._e()], 2), (_vm.metas.extra && _vm.metas.extra['zh-CN']) ? _c('div') : _vm._e(), (_vm.metas.extra && !_vm.metas.extra['zh-CN']) ? _c('div', [_vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4)]) : _vm._e(), (_vm.demos.length) ? _c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "examples"
    }
  }, [_vm._v("Examples")]) : _vm._e(), _c('br'), _vm._l((_vm.demos), function(demo) {
    return (_vm.demos.length) ? [_c('a', {
      staticClass: "anchor",
      attrs: {
        "id": 'examples:' + demo.title
      }
    }, [_vm._v(_vm._s(demo.title))]), _c('br'), _c('div', {
      staticClass: "demo-header"
    }, [_c('span', {
      staticClass: "demo-title"
    }, [_vm._v(_vm._s(demo.title))])]), _c('div', {
      staticClass: "demos",
      style: ({
        height: demo.height
      })
    }, [_c('div', {
      staticClass: "demo-iframe-box"
    }, [_c('lazy-component', [_c('iframe', {
      staticStyle: {
        "margin": "0 auto"
      },
      attrs: {
        "src": _vm.domain + '?no-background-color=' + demo.noBackgroundColor + '&locale=zh-CN&transition=none&hide-nav=true&hide-tab-bar=true#/components/' + demo.file,
        "width": "375",
        "height": "600",
        "border": "0",
        "frameborder": "0"
      }
    })], 1)], 1), _c('div', {
      staticClass: "demo-code-box",
      style: ({
        overflow: demo.height === demo.oriHeight ? 'hidden' : 'scroll'
      })
    }, [_c('div', {
      attrs: {
        "contenteditable": ""
      },
      domProps: {
        "innerHTML": _vm._s(demo.code)
      }
    }), (demo.height === demo.oriHeight) ? _c('div', {
      staticClass: "demo-code-masker",
      on: {
        "click": function($event) {
          demo.height = 'auto'
        }
      }
    }, [_c('div', [_c('img', {
      staticClass: "demo-qr",
      attrs: {
        "width": "100",
        "src": 'https://qr.vux.li/api.php?text=' + encodeURIComponent(_vm.domain + '?locale=zh-CN#/components/' + demo.file)
      }
    }), _c('br'), _c('span', [_c('el-icon', {
      staticClass: "el-icon-arrow-left"
    }), _c('el-icon', {
      staticClass: "el-icon-arrow-right"
    }), _vm._v("\n                    Show code\n                  "), _c('br')], 1)])]) : _vm._e(), (demo.height === 'auto') ? _c('span', {
      staticClass: "hide-code",
      on: {
        "click": function($event) {
          demo.height = demo.oriHeight
        }
      }
    }, [_c('el-icon', {
      staticClass: "el-icon-close"
    })], 1) : _vm._e()])])] : _vm._e()
  }), _vm._l((_vm.componentList), function(component) {
    return [_c('div', [(_vm.componentList.length > 1) ? _c('a', {
      staticClass: "anchor",
      attrs: {
        "id": 'components:' + component.name
      }
    }, [_vm._v(_vm._s(component.name))]) : _c('a', {
      staticClass: "anchor",
      attrs: {
        "id": "api"
      }
    }, [_vm._v("API")]), _c('br'), _c('h2', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.componentList.length > 1),
        expression: "componentList.length > 1"
      }],
      staticClass: "vux-component-name-sub-item"
    }, [_vm._v(_vm._s(component.name))]), (component.meta.items && component.meta.description) ? [_c('div', {
      domProps: {
        "innerHTML": _vm._s(component.meta.description)
      }
    })] : _vm._e(), (component.meta.props) ? [_c('h2', [_vm._v("属性")]), _c('table', [_vm._m(5, true), _c('tbody', _vm._l((component.meta.props), function(prop, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "点击复制",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (i),
          expression: "i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v(_vm._s(i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(_vm.getTypeHTML(prop.type))
        }
      }), _c('td', [_vm._v(_vm._s(prop.default))]), _c('td', {
        domProps: {
          "innerHTML": _vm._s(prop['zh-CN'] ? prop['zh-CN'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', [_vm._v(_vm._s(prop.version || '--'))])])
    }))])] : _vm._e(), (component.meta.events) ? [_c('h2', [_vm._v("事件")]), _c('table', [_vm._m(6, true), _c('tbody', _vm._l((component.meta.events), function(event, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "点击复制",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: ('@' + i),
          expression: "'@' + i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v("@" + _vm._s(i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(event.params ? event.params.replace(/`(.*?)`/g, '<code>$1</code>') : '--')
        }
      }), _c('td', {
        domProps: {
          "innerHTML": _vm._s(event['zh-CN'] ? event['zh-CN'].replace(/`(.*?)`/g, '<code>$1</code>') : '--')
        }
      }), _c('td', [_vm._v(_vm._s(event['version'] || '--'))])])
    }))])] : _vm._e(), (component.meta.slots) ? [_c('h2', [_vm._v("插槽")]), _c('table', [_vm._m(7, true), _c('tbody', _vm._l((component.meta.slots), function(slot, i) {
      return _c('tr', {
        class: {
          'slot-disabled': slot['status'] === 'deprecated'
        }
      }, [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "点击复制",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (i),
          expression: "i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v(_vm._s(i === 'default' ? '默认插槽' : i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(slot['zh-CN'] ? slot['zh-CN'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', [_vm._v(_vm._s(slot['version'] || '--'))])])
    }))])] : _vm._e(), (component.meta.methods) ? [_c('h2', [_vm._v("方法")]), _c('table', [_vm._m(8, true), _c('tbody', _vm._l((component.meta.methods), function(method, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "点击复制",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (i),
          expression: "i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v(_vm._s(i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(method['params'] ? method['params'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', {
        domProps: {
          "innerHTML": _vm._s(method['zh-CN'] ? method['zh-CN'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', [_vm._v(_vm._s(method['version']))])])
    }))])] : _vm._e(), (component.meta.variables) ? [_c('a', {
      staticClass: "anchor",
      attrs: {
        "id": "variables"
      }
    }, [_vm._v("Variables")]), _c('br'), _c('h2', [_vm._v("样式变量")]), _c('table', [_vm._m(9, true), _c('tbody', _vm._l((component.meta.variables), function(variable, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "点击复制",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: ('@' + variable.name),
          expression: "'@' + variable.name",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v("@" + _vm._s(variable.name))])])], 1), _c('td', [(!_vm.$refs['propColor' + i] || (_vm.$refs['propColor' + i][0] && _vm.$refs['propColor' + i][0].style.backgroundColor)) ? _c('em', {
        ref: 'propColor' + i,
        refInFor: true,
        staticClass: "prop-color",
        style: ({
          backgroundColor: variable.value
        })
      }) : _vm._e(), _vm._v("\n                    " + _vm._s(variable.value) + "\n                  ")]), _c('td', [_vm._v(_vm._s(variable['desc']['zh-CN'] || '--'))]), _c('td', [_vm._v(_vm._s(variable.inherited_name))])])
    }))])] : _vm._e(), (component.meta.tips && component.meta.tips['zh-CN']) ? [_c('a', {
      staticClass: "anchor",
      attrs: {
        "id": "tips"
      }
    }, [_vm._v("重要提示及已知问题")]), _c('br'), _c('h2', [_vm._v("重要提示及已知问题")]), _c('div', [_c('ul', _vm._l((component.meta.tips['zh-CN']), function(tip) {
      return _c('li', [_c('el-tag', {
        staticClass: "component-tip-tag",
        attrs: {
          "size": "mini",
          "type": "success"
        }
      }, [_vm._v("Q")]), _c('span', {
        staticClass: "component-tip-question"
      }, [_vm._v(_vm._s(tip.q))]), _c('div', {
        staticClass: "tip-answer-box",
        domProps: {
          "innerHTML": _vm._s(tip.a)
        }
      })], 1)
    }))])] : _vm._e()], 2)]
  }), _c('br'), (_vm.issues.length) ? _c('div', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "Issues"
    }
  }, [_vm._v("Issues")]), _c('br'), _c('h2', [_vm._v("相关 issue")]), _c('ul', _vm._l((_vm.issues), function(issue) {
    return _c('li', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": issue.html_url
      }
    }, [_vm._v("#" + _vm._s(issue.number) + " "), _c('span', {
      staticStyle: {
        "color": "#666"
      }
    }, [_vm._v(_vm._s(issue.title))])])])
  }))]) : _vm._e(), _c('br'), (_vm.gitMetas) ? _c('div', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "contributors"
    }
  }, [_vm._v("贡献者")]), _c('h2', [_vm._v("贡献者")]), _c('p', [_vm._v("该组件(包含文档)迭代次数 " + _vm._s(_vm.gitMetas.commitCount) + "，贡献人数 " + _vm._s(_vm.gitMetas.commitUniqueCount) + "\n        ")]), _vm._l((_vm.gitMetas.commitMembers), function(person) {
    return _c('a', {
      staticClass: "contributor-item",
      attrs: {
        "href": 'https://github.com/' + person.authorName,
        "target": "_blank",
        "title": 'contribute' + person.count
      }
    }, [_vm._v(_vm._s(person.authorName))])
  })], 2) : _vm._e(), _c('br'), (_vm.metas.changes) ? _c('div', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "changelog"
    }
  }, [_vm._v("Changelog")]), _c('br'), _c('h2', [_vm._v("发布日志")]), (_vm.metas.changes) ? _c('ul', [_vm._l((_vm.metas.changes), function(changelog, version) {
    return _vm._l((changelog['zh-CN']), function(log) {
      return _c('li', [_c('router-link', {
        staticClass: "changelog-version",
        attrs: {
          "to": '/zh-CN/changelog/' + version + '.html'
        }
      }, [_vm._v(_vm._s(version))]), _vm._v(" " + _vm._s(log) + "\n            ")], 1)
    })
  })], 2) : _vm._e()]) : _vm._e(), (_vm.metas.references) ? _c('h2', [_vm._v("参考资料")]) : _vm._e(), (_vm.metas.references) ? _c('ul', _vm._l((_vm.metas.references['zh-CN']), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": link.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.title))])])
  })) : _vm._e(), _c('el-dialog', {
    staticClass: "sourcec-code-dialog",
    attrs: {
      "top": "0",
      "width": "80%",
      "visible": _vm.sourceCodeDialogVisibility
    },
    on: {
      "update:visible": function($event) {
        _vm.sourceCodeDialogVisibility = $event
      }
    }
  }, [_c('div', {
    staticClass: "code-box",
    attrs: {
      "contenteditable": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.demoCode)
    }
  })])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("该组件支持以"), _c('code', [_vm._v("plugin")]), _vm._v("形式调用：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v("  { LoadingPlugin } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\nVue.use(LoadingPlugin)\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 或者umd方式")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 引入构建的js文件")]), _vm._v("\nVue.use(vuxLoadingPlugin)\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 显示")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$vux.loading.show({\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("text")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Loading'")]), _vm._v("\n})\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 隐藏")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$vux.loading.hide()\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 获取显示状态")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$vux.loading.isVisible() "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// true or false, v2.9.1 版本支持")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("loading同样支持在vue外直接使用，请参照 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/docs/examples/loading.html"
    }
  }, [_vm._v("https://github.com/airyland/vux/blob/v2/docs/examples/loading.html")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("从v2.7.8版本开始以组件形式调用增加"), _c('code', [_vm._v("delay")]), _vm._v("参数，从而实现延时显示.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("名字")]), _c('td', {
    staticStyle: {
      "width": "48px"
    }
  }, [_vm._v("类型")]), _c('td', [_vm._v("默认值")]), _c('td', [_vm._v("说明")]), _c('td', [_vm._v("版本要求")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("名字")]), _c('td', [_vm._v("参数")]), _c('td', [_vm._v("说明")]), _c('td', [_vm._v("版本要求")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("名字")]), _c('td', [_vm._v("说明")]), _c('td', [_vm._v("版本要求")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("名字")]), _c('td', [_vm._v("参数")]), _c('td', [_vm._v("说明")]), _c('td', [_vm._v("版本要求")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("名字")]), _c('td', [_vm._v("默认值")]), _c('td', [_vm._v("说明")]), _c('td', [_vm._v("继承自变量")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6ba5a284", module.exports)
  }
}

/***/ }),

/***/ 2518:
/***/ (function(module, exports) {

module.exports = {
	"commitCount": 1,
	"commitMembers": [
		{
			"count": 1,
			"authorName": "Bobjoy"
		}
	],
	"commitUniqueCount": 1
};

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1618)
}
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1304),
  /* template */
  __webpack_require__(2311),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/zh-CN/components/loading.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] loading.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6ba5a284", Component.options)
  } else {
    hotAPI.reload("data-v-6ba5a284", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// 51.7ff71a06.js